import { Button, Tooltip } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';

import { RouterOutput, trpc } from '../../../../../../services/trpc';
import ConstructionSiteReviewForm, {
  ConstructionSiteReviewFormValues,
} from './construction-site-review-form';

export function ConstructionSiteReviewButton({
  project,
  label,
  initialValues,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
  label: string;
  initialValues?: ConstructionSiteReviewFormValues;
}) {
  const generateConstructionSiteReview =
    trpc.documents.generateConstructionSiteReview.useMutation();

  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  const openAddCSReviewModal = () => {
    modals.open({
      title: 'Ajouter un compte-rendu de chantier',
      size: 'xl',
      fullScreen: isSmallScreen,
      children: (
        <ConstructionSiteReviewForm
          project={project}
          constructionSiteReview={initialValues || null}
          onSubmit={async (values: ConstructionSiteReviewFormValues) => {
            await generateConstructionSiteReview.mutateAsync({
              projectId: project.id,
              table: values.table,
              importantNotes: values.importantNotes,
              predefinedSentences: values.predefinedSentences,
            });
            modals.closeAll();
            notifications.show({
              title: 'Compte-rendu ajouté avec succès',
              message: '',
              color: 'green',
            });
          }}
        />
      ),
    });
  };

  const handleClick = () => {
    openAddCSReviewModal();
  };

  const isDisabled = !project.technicalPlanTable;
  const button = (
    <Button
      variant="outline"
      leftSection={<IconPlus size={16} />}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {label}
    </Button>
  );

  if (isDisabled) {
    return (
      <Tooltip label="Remplissez d'abord le tableau du plan technique">
        {button}
      </Tooltip>
    );
  }

  return button;
}
